module.exports = __webpack_public_path__ + "static/img/case4.1d4ada2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/case4.png
// module id = jBAU
// module chunks = 19